// src/data/recipes.js
// Recipe articles for the Specials Recipe tab

const recipeArticles = [
  {
    subtitle: 'A spicy and aromatic dry roast chicken, a Mangalorean favorite.',
    subtitleColor: '#b22222',
    aid: 308,
    title: 'Chicken Sukka / Dry Roast',
    aboutdescription: '\n\nDry roast whole spices, prepare fresh coconut masala, cook chicken with onion-tomato base, and roast till dry and flavorful.\n\nPreparation for 1 kg chicken:\n1. Clean and cut 1 kg chicken into medium pieces.\n2. Dry roast spices: 3 tbsp coriander seeds, 1.5 tsp cumin, 1.5 tsp fennel, 2 tsp black pepper, 5-8 cloves, 2 small pieces cinnamon, 2-3 cardamom, and 15 dried red chilies until aromatic.\n3. Add 1/2 medium grated coconut and roast till light golden. Cool and grind to a coarse paste.\n4. Crush 1 garlic bulb and 1 tbsp ginger.\n5. Heat 1 tbsp oil and fry 3 sliced onions till light brown. Add curry leaves and ginger-garlic; saute well.\n6. Add chicken, 1 tsp turmeric powder, and salt to taste. Mix well.\n7. Add 3 sliced tomatoes and cook till chicken releases water. Cover and cook till 80% done.\n8. Add the ground masala and mix well.\n9. Cook uncovered till dry, oil separates, and chicken is well roasted.\nServe hot with neer dosa, roti, or steamed rice.',
    imagepath: '/images/recipesimages/Mangalorean_Chickensukkha.jpg',
    urlshare: '',
    featuredlisting: false,
    listingorder: 1,
    liststatus: 'Active',
    postedtime: 'Mar 25, 2026, 11:00 AM',
    specialcategory: 'Recipe',
    recipeby: 'MangaloreHub Team',
  },

  {
    subtitle: 'A rich and spicy mutton curry, a favorite in Mangalorean homes.',
    subtitleColor: '#8b0000',
    aid: 306,
    title: 'Mutton Masala',
    aboutdescription: '\n\nMarinate mutton, fry onions and spices, add mutton and masala, cook until soft, and enjoy with rice or chapati.\n\nPreparation for 1 kg mutton:\n1. Cut 1 kg mutton into pieces. Marinate with 2 tsp salt, 1/2 tsp turmeric, and 2 tsp chili powder for 45 minutes.\n2. Fry 3 large onions, 2-inch ginger, 10 garlic cloves, and 2 tomatoes until golden.\n3. Add mutton and cook until half done.\n4. Add ground masala (3 tbsp coriander, 1 tbsp cumin, 1 tsp pepper, 1-inch cinnamon, 4 cloves, 8 dried red chilies).\n5. Add 1 cup water, cover, and cook until mutton is tender and gravy thickens (about 40-50 min).\nGarnish with coriander leaves and serve with rice or chapati.',
    imagepath: '/images/recipesimages/Mangalorean_ChickenCurry_masala.jpg',
    urlshare: '',
    featuredlisting: false,
    listingorder: 6,
    liststatus: 'Active',
    postedtime: 'Jan 20, 2026, 10:25 AM',
    specialcategory: 'Recipe',
    recipeby: 'MangaloreHub Team',  
  },
  {
    subtitle: 'A spicy and tangy mutton chilli, perfect as a starter or side dish.',
    subtitleColor: '#a0522d',
    aid: 307,
    title: 'Mutton Chilli',
    aboutdescription: '\n\nMarinate mutton, fry onions and chilies, add sauces and capsicum, stir-fry, and serve hot.\n\nPreparation for 1 kg mutton:\n1. Cut 1 kg mutton into strips. Marinate with 2 tsp salt, 1 tsp pepper, and 2 tbsp vinegar for 45 minutes.\n2. Fry 3 large onions, 10 garlic cloves, and 6 green chilies.\n3. Add mutton and cook until browned.\n4. Add 2 tbsp soy sauce, 3 tbsp tomato sauce, and 1 green capsicum (sliced).\n5. Stir-fry until mutton is cooked and sauce thickens.\nServe hot as an appetizer or with fried rice.',
    imagepath: '/images/recipesimages/Mangalorean_Chicken_chilli.jpg',
    urlshare: '',
    featuredlisting: false,
    listingorder: 7,
    liststatus: 'Active',
    postedtime: 'Jan 20, 2026, 10:30 AM',
    specialcategory: 'Recipe',
    recipeby: 'MangaloreHub Team',

  },
  {
    subtitle: 'A tangy and spicy chicken chilli, a Mangalorean favorite.',
    subtitleColor: '#1976d2',
    aid: 303,
    title: 'Chicken Chilli',
    aboutdescription: '\n\nMarinate chicken, fry onions and chilies, add sauces and capsicum, stir-fry, and serve hot.\n\nPreparation for 1 kg chicken:\n1. Cut 1 kg chicken into strips. Marinate with 1.5 tsp salt, 1 tsp pepper, and juice of 1 lemon for 30 minutes.\n2. Fry 3 large onions, 10 garlic cloves, and 6 green chilies.\n3. Add chicken and cook until golden.\n4. Add 2 tbsp soy sauce, 3 tbsp tomato sauce, and 1 capsicum (sliced).\n5. Stir-fry until chicken is cooked and sauce is thick.\nGarnish with spring onions and serve hot.',
    imagepath: '/images/recipesimages/Mangalorean_Chicken_chilli.jpg',
    urlshare: '',
    featuredlisting: false,
    listingorder: 2,
    liststatus: 'Active',
    postedtime: 'Jan 20, 2026, 10:10 AM',
    specialcategory: 'Recipe',
    recipeby: 'MangaloreHub Team',
  },
  {
    subtitle: 'A spicy and flavorful pork masala dish, a Mangalorean favorite.',
    subtitleColor: '#a52a2a',
    aid: 301,
    title: 'Pork Masala',
    aboutdescription: '\n\nMarinate pork, fry onions and spices, add pork and masala, cook until soft, and enjoy with rice or sannas.\n\nPreparation for 1 kg pork:\n1. Cut 1 kg pork into medium pieces. Marinate with 2 tsp salt, 1/2 tsp turmeric, and 2 tsp chili powder for 45 minutes.\n2. Fry 3 large onions, 2-inch ginger, 10 garlic cloves, and 6 green chilies.\n3. Add marinated pork and cook until tender.\n4. Add ground masala (3 tbsp coriander, 1 tbsp cumin, 1 tsp pepper, 1-inch cinnamon, 4 cloves, 8 dried red chilies).\n5. Simmer until oil separates and pork is soft (about 40 min).\n6. Garnish with coriander leaves.\nServe hot with rice or sannas.',
    imagepath: '/defaultimages/imagenotavailable.jpg',
    urlshare: '',
    featuredlisting: false,
    listingorder: 3,
    liststatus: 'Active',
    postedtime: 'Jan 20, 2026, 10:00 AM',
    specialcategory: 'Recipe',
    recipeby: 'MangaloreHub Team',
  },
  {
    subtitle: 'A spicy and tangy pork chilli, a Mangalorean delicacy.',
    subtitleColor: '#c0392b',
    aid: 302,
    title: 'Pork Chilli',
    aboutdescription: '\n\nMarinate pork, fry onions and chilies, add sauces and capsicum, stir-fry, and serve hot.\n\nPreparation for 1 kg pork:\n1. Cut 1 kg pork into strips. Marinate with 2 tsp salt, 1 tsp pepper, and 2 tbsp vinegar for 45 minutes.\n2. Fry 3 large onions, 10 garlic cloves, and 6 green chilies.\n3. Add pork and cook until browned.\n4. Add 2 tbsp soy sauce, 3 tbsp tomato sauce, and 1 green capsicum (sliced).\n5. Stir-fry until pork is cooked and sauce thickens.\nServe hot as an appetizer or with fried rice.',
    imagepath: '/defaultimages/imagenotavailable.jpg',
    urlshare: '',
    featuredlisting: false,
    listingorder: 4,
    liststatus: 'Active',
    postedtime: 'Jan 20, 2026, 10:05 AM',
    specialcategory: 'Recipe',
    recipeby: 'MangaloreHub Team',
  },
];

export default recipeArticles;
